"use client";

import React, { createContext, useContext, useState, useEffect } from "react";

interface TenantInfo {
  storeName: string;
  logoUrl?: string | null;
  outletId: string;
  prefix: string;
}

interface TenantContextValue extends TenantInfo {
  setTenant: (info: TenantInfo) => void;
}

const STORAGE_KEY = "shop_tenant";

const TenantContext = createContext<TenantContextValue | null>(null);

export function TenantProvider({ children }: { children: React.ReactNode }) {
  const [info, setInfo] = useState<TenantInfo>({
    storeName: "GrabLocal",
    logoUrl: null,
    outletId: "",
    prefix: "",
  });

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) setInfo(JSON.parse(stored));
    } catch { /* ignore */ }
  }, []);

  const setTenant = (next: TenantInfo) => {
    setInfo(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };

  return (
    <TenantContext.Provider value={{ ...info, setTenant }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  const ctx = useContext(TenantContext);
  if (!ctx) throw new Error("useTenant must be used within TenantProvider");
  return ctx;
}
